import { useState } from 'react';
import * as S from './SwitchButton.styles';
import { SwitchButtonPropsInterface } from './switchBtn.interface';

const SwitchButton = ({ defaultChecked = false, disabled = false, label, onChange }: SwitchButtonPropsInterface) => {
  const [checked, setChecked] = useState(defaultChecked);
  //   const handleChage = (e: any) => {
  //     onChange(isChecked);
  //   };

  return (
    <S.Wrapper>
      {label && <S.Label>{label}</S.Label>}
      <S.FieldWrapper
        $checked={checked}
        $disabled={disabled}
        onClick={() => {
          if (!disabled) {
            onChange(!checked);
            setChecked(!checked);
          }
        }}
      >
        <S.Bullet $checked={checked} $disabled={disabled} />
      </S.FieldWrapper>
    </S.Wrapper>
  );
};

export default SwitchButton;
